import { Component, OnInit, Output, EventEmitter, SimpleChanges, AfterViewChecked } from '@angular/core';
import { UtilService, DialogService, DatagridService } from '../../shared/index'; //app/shared/index barrel;
import { NumberValueAccessor, CreateNumberValueAccessorProvider } from '../../shared/widgets/value-accessors/number-value-accessor';
import { TranslationService } from '../../shared/translation/translation.service';

import { InvoiceService } from '../shared/invoice/invoice.service';
import { Invoice } from '../shared/invoice/invoice.model';
import { InvoiceSearchParams } from '../shared/invoice/invoice-search-params.model';
import { InvoiceSearchResult } from '../shared/invoice/invoice-search-result.model';
import { RevenueItemService } from '../shared/revenue-items/revenue-item.service';
import { RevenueItem } from '../shared/revenue-items/revenue-item.model';

@Component({
  selector: 'wl-invoice-lookup',
  templateUrl: 'invoice-lookup.component.html',
  providers: [InvoiceService, CreateNumberValueAccessorProvider(InvoiceLookupComponent), RevenueItemService],
    standalone: false
})
export class InvoiceLookupComponent extends NumberValueAccessor implements OnInit, AfterViewChecked {
  @Output() onInvoiceChanged = new EventEmitter<Invoice>();

  public _utilService: UtilService;
  public _invoiceService: InvoiceService;
  public _dataGridService: DatagridService;
  public _dialogService: DialogService;
  public _translateService: TranslationService;
  public _lastValue: number;
  public _revenueItemService: RevenueItemService;

  public searchHasResults: boolean;
  public invoiceSearchParams: InvoiceSearchParams;
  public invoiceResults: InvoiceSearchResult;
  public errorMessage: string;
  public searchPerformed: boolean;
  public isSearching: boolean;
  public profileName: string;
  public displayName: string;
  public showModal = false;
  public selectedInvoice: Invoice;
  public searchOnOpen: boolean;

  public amountDueLabel: string;
  public noneText = '';

  public selectedRevenueItemNum: number;
  public revenueItems: Array<RevenueItem>;

  public constructor(
    utilService: UtilService,
    translateService: TranslationService,
    invoiceService: InvoiceService,
    dataGridService: DatagridService,
    dialogService: DialogService,
    revenueItemService: RevenueItemService
  ) {
    super();
    this._utilService = utilService;
    this._translateService = translateService;
    this._invoiceService = invoiceService;
    this._dataGridService = dataGridService;
    this._dialogService = dialogService;
    this._revenueItemService = revenueItemService;

    this.invoiceSearchParams = new InvoiceSearchParams();
    this.invoiceSearchParams.Keyword = '';
    this.invoiceSearchParams.OrderBy = 'AdjustedAmountDue:desc';

    this.invoiceResults = new InvoiceSearchResult();
    this.searchHasResults = false;
    this.searchPerformed = false;
    this.isSearching = false;
    this.profileName = '';
    this.displayName = '';
    this._lastValue = -1;
    this.selectedInvoice = new Invoice();
    this.searchOnOpen = false;

    this.amountDueLabel = '';

    this.noneText = '';

    this.selectedRevenueItemNum = 0;
    this.revenueItems = new Array<RevenueItem>();
  }

  ngOnInit(): void {
    this._translateService.get('common.none').then((data: string) => {
      this.noneText = data;
      this.displayName = this.noneText;
    });
    this._translateService.get('common.revenue.amount-due').then((data: string) => {
      this.amountDueLabel = data;
    });
    this._revenueItemService.getRevenueItems().then((data: Array<RevenueItem>) => {
      this.revenueItems = data;
      var blankRevItem = new RevenueItem();
      blankRevItem.ItemName = '';
      blankRevItem.ItemNum = 0;

      this._utilService.arrayAddEntryToBeginning(this.revenueItems, blankRevItem);
    });
  }

  public showSearch = (): void => {
    //if (this.searchOnOpen == true) {

    //    this.executeSearch(null);
    //}

    this.showModal = true;
  };

  public hideSearch = (): void => {
    this.showModal = false;
  };

  public executeSearch = (event: any = null): void => {
    if (this.selectedRevenueItemNum > 0) {
      this.invoiceSearchParams.ItemNum = this.selectedRevenueItemNum;
    } else {
      this.invoiceSearchParams.ItemNum = 0;
    }

    this._dataGridService.mapDatagridPagingToPagedSearch(event, this.invoiceSearchParams);

    this.isSearching = true;

    this._invoiceService.search(this.invoiceSearchParams).then(
      (data: InvoiceSearchResult) => {
        //update the search params based on current page number etc
        this._dataGridService.mapPagedResultsToPagedSearch(data, this.invoiceSearchParams);
        if (data.TotalCount > 0) {
          this.searchHasResults = true;
        } else {
          this.searchHasResults = false;
        }
        this.searchPerformed = true;
        this.isSearching = false;

        this.invoiceResults = data;
      },
      (error: any) => {
        this.errorMessage = <any>error;
        this.searchPerformed = true;
        this.isSearching = false;
      }
    );
  };

  public selectInvoice = (invoiceNum: number): void => {
    this.value = invoiceNum;
    for (let invoice of this.invoiceResults.Result) {
      if (invoice.InvoiceNum == invoiceNum) {
        this.selectedInvoice = invoice;
      }
    }

    this.displayName =
      this.selectedInvoice.BillToName +
      ' ' +
      this.amountDueLabel +
      ' ' +
      this._utilService.formatAsCurrencyString(this.selectedInvoice.AdjustedAmountDue);
    //this.getProfile();
    this.hideSearch();

    this.emitOutputObject();
  };

  ngAfterViewChecked() {
    //this.getProfile();
  }

  ngOnChanges(changes: SimpleChanges) {
    //this.getProfile();
  }
  modelChange() {
    this.emitOutputObject();
  }

  emitOutputObject = (): void => {
    this.onInvoiceChanged.emit(this.selectedInvoice);
  };

  public clearForm = (): void => {
    this.displayName = this.noneText;
    this.selectedInvoice = new Invoice();
    this.value = 0;
  };

  public onRevenueItemChange = (data: string): void => {
    this.selectedRevenueItemNum = parseInt(data);
  };
}
